export default __webpack_public_path__ + "static/media/chato-upute.306a961b.pdf";